/**
 * quoteStorage.js
 * Uploads a PDF Blob to Firebase Storage and returns the download URL.
 *
 * Storage path:  quote-pdfs/{quoteNumber}.pdf
 */

import { storage } from '@/firebaseConfig'
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage'

export async function uploadQuotePdf(quoteNumber, pdfBlob) {

  const path    = `quote-pdfs/${quoteNumber}.pdf`
  const fileRef = ref(storage, path)

  const metadata = {
    contentType:        'application/pdf',
    contentDisposition: `attachment; filename="${quoteNumber}.pdf"`,
    customMetadata: {
      quoteNumber,
      uploadedAt: new Date().toISOString(),
    },
  }

  try {
    const snapshot = await uploadBytes(fileRef, pdfBlob, metadata)
    const url      = await getDownloadURL(snapshot.ref)
    return url
  } catch (e) {
    console.error('uploadQuotePdf failed:', e)
    throw e
  } 
}